import { signerToEcdsaValidator } from '@zerodev/ecdsa-validator';
import { toMultiChainECDSAValidator } from '@zerodev/multi-chain-ecdsa-validator';
import type {
  EntryPointType,
  GetKernelVersion,
  Signer,
} from '@zerodev/sdk/types';
import type { Client } from 'viem';
import type { EntryPointVersion } from 'viem/account-abstraction';

type GetEcdsaValidatorParams = {
  ecdsaProviderType?: string;
  entryPoint: EntryPointType<EntryPointVersion>;
  kernelVersion: GetKernelVersion<EntryPointVersion>;
  publicClient: Client;
  signer: Signer;
};

export const getEcdsaValidator = ({
  ecdsaProviderType,
  publicClient,
  signer,
  entryPoint,
  kernelVersion,
}: GetEcdsaValidatorParams) => {
  const params = {
    entryPoint,
    kernelVersion,
    signer,
  };

  if (ecdsaProviderType === 'zerodev_multi_chain') {
    return toMultiChainECDSAValidator(publicClient, params);
  }

  return signerToEcdsaValidator(publicClient, params);
};
